import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { API, errMsg } from "../lib/api";
import { SegmentedBar, PageHeader } from "../components/bits";
import { toast } from "sonner";

export default function Topics() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    API.get("/dashboard").then(({ data }) => setData(data))
      .catch((e) => toast.error(errMsg(e)));
  }, []);

  return (
    <div data-testid="topics-page" className="max-w-6xl">
      <PageHeader title="Question bank" sub="Choose a topic to configure your session — or practise across everything.">
        <button data-testid="all-topics-card-btn" onClick={() => navigate("/app/topics/all")}
          className="flex items-center gap-2 bg-primary text-primary-foreground px-5 py-2.5 rounded-md text-sm font-medium hover:bg-primary/90 transition-colors">
          <LayoutGrid className="w-4 h-4" /> All topics
        </button>
      </PageHeader>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {(data?.topics || []).map((t) => {
          const acc = t.attempted ? Math.round((t.correct / t.attempted) * 100) : null;
          return (
            <button key={t.slug} data-testid={`topic-card-${t.slug}`} onClick={() => navigate(`/app/topics/${t.slug}`)}
              className="text-left bg-card border border-border rounded-lg p-6 shadow-sm hover:shadow-md hover:border-primary/40 transition-all duration-200 group">
              <h3 className="font-display font-semibold text-lg uppercase tracking-wide group-hover:text-primary transition-colors">{t.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground">
                {t.published} {t.published === 1 ? "question" : "questions"}
                {acc !== null && ` · ${acc}% accuracy`}
              </p>
              <div className="mt-4">
                <SegmentedBar correct={t.correct} incorrect={t.incorrect} total={t.published} />
                <p className="mt-2 text-xs text-muted-foreground">{t.attempted} / {t.published} attempted</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
